import { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Link } from "react-router-dom";

const CatalogueAccordion = ({ data }) => {
  const [openCatalogueId, setOpenCatalogueId] = useState(null);

  const toggleCatalogue = (id) => {
    setOpenCatalogueId((prev) => (prev === id ? null : id));
  };

  return (
    <div className="">
      {data.map((catalogue) => (
        <div
          key={catalogue.catalogue_id}
          className="bg-white  border-b overflow-hidden"
        >
          {/* ===== Catalogue Header ===== */}
          <button
            onClick={() => toggleCatalogue(catalogue.catalogue_id)}
            className="w-full flex items-center justify-between px-4 py-3"
          >
            <div className="flex items-center gap-3 flex-1 overflow-hidden min-w-0">
              <img
                src={`https://backend.nuhababy.com/${catalogue.catalouge_image_path}`}
                alt={catalogue.title}
                loading="lazy"
                decoding="async"
                className="w-6 h-6 object-contain"
              />
              <Link
                to={`/category/${catalogue.catalogue_id}`}
                className="min-w-0 flex-1"
              >
                <span className="text-xs font-medium text-left truncate whitespace-nowrap max-w-[140px] block">
                  {catalogue.title}
                </span>
              </Link>
            </div>
            {catalogue.subcatalogues?.length > 0 ? (
              openCatalogueId === catalogue.catalogue_id ? (
                <FaChevronUp className="h-2 w-2" />
              ) : (
                <FaChevronDown className="h-2 w-2" />
              )
            ) : null}
          </button>

          {/* ===== Subcatalogues ===== */}
          {openCatalogueId === catalogue.catalogue_id && (
            <div className="px-4">
              {catalogue.subcatalogues?.length > 0 ? (
                <div className="flex flex-col pb-2">
                  {catalogue.subcatalogues.map((sub) => (
                    <div
                      key={sub.subCatalogue_id}
                      className="flex items-center space-x-3 text-black hover:text-backgroundColor  cursor-pointer py-2 px-4"
                    >
                      <img
                        src={`https://backend.nuhababy.com/${sub.image_path}`}
                        alt={sub.title}
                        className="w-6 h-6 object-contain"
                      />
                      <Link
                        to={`/subCategory/${sub.subCatalogue_id}`}
                        className="min-w-0 flex-1"
                      >
                        <span className="text-xs font-medium truncate text-left max-w-[140px] whitespace-nowrap block">
                          {sub.title}
                        </span>
                      </Link>
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CatalogueAccordion;
